export type GoalWeightField = "importance" | "willingness";
export type GoalWeightLevel = "low" | "medium" | "high";

export const GOAL_WEIGHT_OPTIONS: Record<
  GoalWeightField,
  Array<{ key: GoalWeightLevel; label: string; value: number }>
> = {
  importance: [
    { key: "low", label: "Light", value: 0.25 },
    { key: "medium", label: "Meaningful", value: 0.5 },
    { key: "high", label: "Core", value: 0.8 },
  ],
  willingness: [
    { key: "low", label: "Low pull", value: 0.25 },
    { key: "medium", label: "Mixed", value: 0.5 },
    { key: "high", label: "Ready", value: 0.8 },
  ],
};

export function clampGoalWeight(value?: number | null) {
  if (typeof value !== "number" || Number.isNaN(value)) return 0.5;
  return Math.max(0, Math.min(1, value));
}

export function goalWeightLevel(value: number | null | undefined): GoalWeightLevel {
  const normalized = clampGoalWeight(value);
  if (normalized >= 0.7) return "high";
  if (normalized <= 0.35) return "low";
  return "medium";
}

export function goalWeightLabel(field: GoalWeightField, value: number | null | undefined) {
  const level = goalWeightLevel(value);
  return GOAL_WEIGHT_OPTIONS[field].find((option) => option.key === level)?.label ?? "Mixed";
}
